// import { makeAPICall } from "../../common";
import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_TABLE_TYPE = "GET_TABLE_TYPE";
export const GET_TABLE_TYPE_SUCCESS = "GET_TABLE_TYPE_SUCCESS";
export const GET_TABLE_TYPE_FAILED = "GET_TABLE_TYPE_FAILED";

export const GET_OPERATIONAL_DASHBOARD = "GET_OPERATIONAL_DASHBOARD";
export const GET_OPERATIONAL_DASHBOARD_SUCCESS =
  "GET_OPERATIONAL_DASHBOARD_SUCCESS";
export const GET_OPERATIONAL_DASHBOARD_FAILED =
  "GET_OPERATIONAL_DASHBOARD_FAILED";

export const GET_WORKFLOW_DETAILS = "GET_WORKFLOW_DETAILS";
export const GET_WORKFLOW_DETAILS_SUCCESS = "GET_WORKFLOW_DETAILS_SUCCESS";
export const GET_WORKFLOW_DETAILS_FAILED = "GET_WORKFLOW_DETAILS_FAILED";

export function triggerFetchTableType(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}operationalDashboard`,
      dispatch,
      params: obj.param,
      headers: obj.headers,
      defaultAction: GET_TABLE_TYPE,
      successAction: GET_TABLE_TYPE_SUCCESS,
      failedAction: GET_TABLE_TYPE_FAILED,
      type: "POST",
      callback: callback,
    };
    makeAPICall(params);
  };
}

export function triggerFetchOperationalDashboard(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}operationalDashboard`,
      dispatch,
      params: obj.param,
      headers: obj.headers,
      defaultAction: GET_OPERATIONAL_DASHBOARD,
      successAction: GET_OPERATIONAL_DASHBOARD_SUCCESS,
      failedAction: GET_OPERATIONAL_DASHBOARD_FAILED,
      type: "POST",
      callback: callback,
      extraData: obj.headers,
    };
    makeAPICall(params);
  };
}

export function triggerFetchWorkFlow(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}operationalDashboard`,
      dispatch,
      params: obj.param,
      headers: obj.headers,
      defaultAction: GET_WORKFLOW_DETAILS,
      successAction: GET_WORKFLOW_DETAILS_SUCCESS,
      failedAction: GET_WORKFLOW_DETAILS_FAILED,
      type: "POST",
      callback: callback,
      extraData: obj.headers,
    };
    makeAPICall(params);
  };
}
